import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ModalConfirm } from "../../ModalConfirm";

/**
 * The premium prompt: what the feature is, and the way to get it. Same shape
 * as the one on Pages/NPWPValidate and the period-close panel, so a free member
 * meets one prompt wherever they reach a paid feature.
 */
const PremiumFeatureModal = ({ open, setOpen, description }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ModalConfirm
      open={open}
      setOpen={setOpen}
      type="WARNING"
      title={t("premium.alert.title")}
      description={description}
      confirmTitle={t("premium.action.subscribe")}
      onConfirm={() => navigate("/subscription")}
    />
  );
};

/**
 * A small "Premium" mark beside a control a free member can press but not
 * use. The control stays enabled and explains itself on click - a silently
 * disabled button teaches nothing.
 */
export const PremiumTag = () => {
  const { t } = useTranslation();
  return (
    <span className="ml-2 inline-flex items-center rounded bg-blue-50 px-1.5 py-0.5 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20">
      {t("premium.label")}
    </span>
  );
};

export default PremiumFeatureModal;
